module.exports = __webpack_public_path__ + "assets/images/slope-working/desktop.svg?v=696329c2";